import React from 'react';
import { Helmet } from 'react-helmet-async';
import './MentionsLegales.css';

function MentionsLegales() {
  return (
    <div className="mentions-page">
      <Helmet>
        <title>Mentions légales — Eagle Car's</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="page-header">
        <h1 className="section-title">Mentions <span>Légales</span></h1>
        <div className="gold-line centered" />
      </div>

      <div className="mentions-body container">

        <section>
          <h2>Éditeur du site</h2>
          <p><strong>Raison sociale :</strong> EAGLE CAR'S</p>
          <p><strong>Forme juridique :</strong> SAS (Société par Actions Simplifiée)</p>
          <p><strong>Capital social :</strong> 100,00 €</p>
          <p><strong>SIREN :</strong> 938 950 565</p>
          <p><strong>SIRET :</strong> 938 950 565 00011</p>
          <p><strong>N° TVA intracommunautaire :</strong> FR31 938 950 565</p>
          <p><strong>Immatriculation :</strong> RNE — immatriculée le 20/02/2025</p>
          <p><strong>Code NAF/APE :</strong> 45.11Z — Commerce de voitures et de véhicules automobiles légers</p>
          <p><strong>Date de création :</strong> 08/10/2024</p>
          <p><strong>Adresse :</strong> 40 Route de la Libération, 74100 Étrembières, France</p>
          <p><strong>Téléphone :</strong> 06 76 79 67 71</p>
          <p><strong>Email :</strong> contact@eaglecars.fr</p>
        </section>

        <section>
          <h2>Responsable de publication</h2>
          <p>Herolind PIRA — Président de la SAS EAGLE CAR'S</p>
          <p>Contact : <a href="mailto:garage.eagle.cars@gmail.com">garage.eagle.cars@gmail.com</a></p>
        </section>

        <section>
          <h2>Hébergement</h2>
          <p><strong>Hébergeur :</strong> Hetzner Online GmbH</p>
          <p><strong>Adresse :</strong> Industriestr. 25, 91710 Gunzenhausen, Allemagne</p>
          <p><strong>Site :</strong> www.hetzner.com</p>
        </section>

        <section>
          <h2>Collecte de données personnelles</h2>
          <p>
            Le formulaire de contact collecte les données suivantes : nom, adresse email, numéro de téléphone et message.
            Ces données sont utilisées uniquement pour répondre à vos demandes et ne sont pas transmises à des tiers.
            Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.
            Pour exercer ce droit, contactez-nous à <a href="mailto:garage.eagle.cars@gmail.com">garage.eagle.cars@gmail.com</a>.
          </p>
        </section>

        <section>
          <h2>Cookies</h2>
          <p>Ce site n'utilise pas de cookies de traçage ou publicitaires.</p>
        </section>

        <section>
          <h2>Propriété intellectuelle</h2>
          <p>
            L'ensemble du contenu de ce site (textes, images, logos) est la propriété exclusive de EAGLE CAR'S.
            Toute reproduction, même partielle, est interdite sans autorisation préalable.
          </p>
        </section>

      </div>
    </div>
  );
}

export default MentionsLegales;
